import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, ValidationErrors } from '@angular/forms';
import { FormError, provideRefs } from 'asap-team/asap-tools';

@Component({
  selector: 'iq-form-control-text',
  templateUrl: './iq-form-control-text.component.html',
  styleUrls: ['./iq-form-control-text.component.sass'],
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: provideRefs(IqFormControlTextComponent),
})
export class IqFormControlTextComponent implements ControlValueAccessor {

  @ViewChild('nativeInput', { static: true, read: ElementRef }) nativeInput: ElementRef<HTMLInputElement>;

  @Input() autofocus: boolean = false;

  @Input() label: string | null = null;

  @Input() labelStyle: 'wide' | null = null;

  @Input() placeholder: string | null = null;

  @Input() icon: string;

  @Input() lpignore: boolean = true;

  @Input() errorsModel: FormError[] | string[];

  @Input() formControlName: string;

  focused: boolean = false;

  disabled: boolean = false;

  constructor(
    private renderer2: Renderer2,
  ) {}

  onChange: any = () => {};

  onTouched: any = () => {};

  writeValue(value: string): void {
    this.renderer2.setProperty(this.nativeInput.nativeElement, 'value', value);
  }

  registerOnChange(callback: any): void {
    this.onChange = callback;
  }

  registerOnTouched(callback: any): void {
    this.onTouched = callback;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.renderer2.setProperty(this.nativeInput.nativeElement, 'disabled', isDisabled);
  }

  validate(): ValidationErrors | null {
    return null;
  }

  blur(): void {
    this.focused = false;
    this.onTouched();
  }

  input(event: any): void {
    this.onChange(event.target.value);
  }

  getNativeElementRef(): ElementRef<HTMLButtonElement> {
    return this.nativeInput;
  }

}
